import {WebConferenceState} from "@share/web-conferences/store/WebConferenceState";

export const state: WebConferenceState = {
    joinedUserIds: {},
    presenters: {},
    agora: null,
    stateHelper: null,
    raisedHandUsers: {},
    removedSpeakers: {},
    recordingStarted: {},
    deviceTestState: {
        deviceState: {
            micIsOn: true,
            videoIsOn: true
        },
        selectedDevices: {
            audioDeviceId: "",
            videoDeviceId: ""
        }
    },
    webConferenceData: {},
    tracksManager: {}
}
